import { FormikProps, FormikProvider } from "formik";
import { RefObject } from "react";

import { MediaImage, MediaImageProps } from "@uderly/react-uderly-ui";
import { IndexedRow, ModuleHandle, Media } from "@uderly/react-uderly-ui/models";
import Settings from "../../../settings";
import ModuleType from "../models/ModuleType";
import React from "react";

const useMediaImage = (item: IndexedRow, moduleRef: undefined | RefObject<ModuleHandle>, data: ModuleType) => {
  const onImageFileChanged = (imageFile: File, { values, setFieldValue }: FormikProps<any>, collectionName = "image") => {
    const m = {
      name: imageFile.name,
      size: imageFile.size,
      mime_type: imageFile.type,
      collection_name: collectionName
    };

    const updatedMedia = !values.media ? [m] :
      [...values.media.filter((m: Media) => m.collection_name && m.collection_name !== collectionName), m];

    if (values) {
      setFieldValue("media", updatedMedia);
    }

    return updatedMedia;
  };

  const onImageRemoved = (media: Media, { values, setFieldValue }: FormikProps<any>) => {
    // TODO: This is inconsistent and likely a bug, when media 
    // is given as a prop, it is an array and it should not be
    if (media instanceof Array)
      media = media[0];

    console.log(media)
    if (media && values.media) {
      const filtered = values.media.filter((m: Media) => m.id !== media?.id);

      setFieldValue("media", filtered);
    }
  }

  const renderComponent = (formikProps: FormikProps<any>,
    mediaImageProps: MediaImageProps | undefined = {}, collectionName = "image") => {
    let imageUrl: (string | null) = null;
    let imageMedia: Media[] | undefined;

    if (formikProps.values.id) {
      imageMedia = formikProps.values.media.filter((m: Media) => m.collection_name === collectionName);

      if (item && imageMedia && Array.isArray(imageMedia) && imageMedia.length > 0 && imageMedia[0].id)
        imageUrl = `${Settings.apiUrl}${data.apiBasePath}/${item.id}/image?collectionName=${collectionName}`;
    }

    return <FormikProvider value={formikProps}>
      <MediaImage
        variant="squircle"
        imageUrl={imageUrl}
        item={item}
        media={imageMedia as [] ?? undefined}
        onImageRemoved={(media: Media) => onImageRemoved(media, formikProps)}
        onImageFileChanged={(imageFile: File) => onImageFileChanged(imageFile, formikProps, collectionName)}
        {...mediaImageProps} /></FormikProvider>
  }
  return { onImageFileChanged, onImageRemoved, renderComponent };
}

export default useMediaImage;